import vuei18n from '@/plugins/vue-i18n';

export function getFieldsByForm(authorizationForms) {
  const firstStep = authorizationForms
    .map(form => ({ key: form.formSlug, label: form.fallbackName, coverageType: form.authorizationCoverage}));

  const forms = authorizationForms
  .map(form => ({ form: form.formSlug }))

  const fieldsByForm = forms.reduce((acc, current) => {
    return {
      ...acc,
      [current.form]: [
        [
          {
            required: true,
            label: vuei18n.t('addAuthorization.fields.type'),
            type: 'SELECT',
            options: firstStep,
            slug: 'forms',
            description: '',
            groupName: vuei18n.t('addAuthorization.fields.type')
          }
        ]
      ]
    }
  }, {});

  authorizationForms.forEach(form => {
    const fieldsByGroup = getFormFields(form).reduce((actual, current) => {
      actual[current.groupName] = actual[current.groupName] || [];
      actual[current.groupName].push(current);
      return actual;
    }, {})
    let mins = []
    Object.keys(fieldsByGroup)
    .forEach(group => {
      const min = fieldsByGroup[group].reduce((actual, current) => {
        return actual.showOrder < current.showOrder ? actual : current;
      })
      mins.push(min);
    })

    const order = mins.sort((a,b) => {
      if (a.showOrder > b.showOrder) return 1;
      if (b.showOrder > a.showOrder) return -1;
      return 0;
    });

    order.forEach(step => {
      let formGroup;
      Object.keys(fieldsByGroup)
      .forEach(group => {
        const act = fieldsByGroup[group].find(value => value === step);
        if (act) {
          formGroup = fieldsByGroup[group].sort((a,b) => {
            if (a.showOrder > b.showOrder) return 1;
            if (b.showOrder > a.showOrder) return -1;
            return 0;
          });
        }
      })
      fieldsByForm[form.formSlug].push(formGroup);
      formGroup = null;
    })
  })
  return fieldsByForm;
}

export function getFormFields(form) {
  const { authorizationCoverage, fields } = form
  if (authorizationCoverage === 'CREDIT_CARD_BALANCE') {
    return fields.filter(field => field.slug !== 'settlement_files')

  }

  return fields
}

export function formatDecimal(value) {
  return value ? value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
}
